export default __webpack_public_path__ + "static/6915-5eda88bf55bcdd34286214dc47e204b5.jpg";